// Simple fallback recommendation system
function getSimpleFallbackRecommendations() {
  console.log('🧠 Using simple fallback recommendations...');
  
  return {
    summary: "You're a dedicated dancer with unique qualities that make you special on stage! While our AI coach is temporarily unavailable, we've selected some versatile variations that work well for many dancers.",
    perfectMatches: [
      {
        variation: "Sugar Plum Fairy Variation",
        ballet: "The Nutcracker", 
        insight: "This beloved variation combines technical elements with beautiful artistry, making it perfect for showcasing your developing skills and stage presence."
      },
      {
        variation: "Peasant Variation",
        ballet: "Giselle",
        insight: "A wonderful choice that lets you explore lyrical movement and character development while building confidence in your performance quality."
      }
    ],
    challengeVariation: {
      variation: "Kitri Act III Variation",
      ballet: "Don Quixote",
      insight: "This spirited variation will help you develop boldness and technical precision while exploring a completely different character style."
    },
    coachingNote: "These variations from our approved repertoire will help you grow as an artist and discover new aspects of your dancing."
  };
}

export async function getVariationRecommendations(rawAnswers) {
  console.log('🎭 Starting AI recommendation generation...');
  console.log('📝 Raw quiz answers received:', rawAnswers);

  try {
    // Call the secure API endpoint instead of OpenAI directly
    const apiUrl = process.env.NODE_ENV === 'production'
      ? '/api/get-variation-recommendations'
      : 'http://localhost:3000/api/get-variation-recommendations';

    console.log('🚀 Calling secure API endpoint...');

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ rawAnswers }),
    });

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`);
    }

    const recommendations = await response.json();
    console.log('✅ Recommendations received from API');
    console.log('🎯 Recommendations:', recommendations);

    return recommendations;

  } catch (error) {
    console.error('❌ Error getting AI recommendations:', error);
    console.error('🔍 Error details:', error.message);

    // Use simple fallback recommendations
    console.log('🧠 Using simple fallback recommendations...');
    return getSimpleFallbackRecommendations();
  }
}

// Simplified function to pass raw quiz data without complex formatting
export function formatQuizAnswers(answers) {
  // Just return the raw answers - let AI figure it out
  return answers;
} 